import type {LegacyId, SourceInfoRequest, InputMapsInfo, SourceInfo} from "#material-maps-exporter/core/types"
import type {MapsExporterDataSource} from "#material-maps-exporter/core/data-source"
import {gatherMaterialData} from "#material-maps-exporter/core/gather-material-data"

export async function gatherMaterialDataForPbrExport(
    dataSource: MapsExporterDataSource,
    materialId: {legacyId: LegacyId} | {id: string},
    request: SourceInfoRequest,
): Promise<{
    mapsInfo: InputMapsInfo
    sourceInfo: SourceInfo
}> {
    if (request.source !== "materialRevision") {
        throw Error("Using texture set as source for maps export no longer supported")
    }

    const {mapsInfo, materialRevisionDetails} = await gatherMaterialData(dataSource, materialId)

    return {
        mapsInfo,
        sourceInfo: {
            type: "sourceInfo",
            source: "materialRevision",
            sourceId: materialRevisionDetails.legacyId,
            textureRevisionInfo: undefined,
        },
    }
}
